import React from 'react';
import { useMediaQuery } from '@material-ui/core';

import Welcome from './Welcome';
import TerraceWelcome from "./TerraceWelcome";
import CarportWelcome from "./CarportWelcome";

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
};

const Dashboard = () => {
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return isXSmall ? (
        <div>
            <div style={styles.flexColumn}>
                <div style={{ marginBottom: '12em' }}>
                    <Welcome />
                </div>
                <div style={styles.singleCol}>
                    <TerraceWelcome />
                </div>
                <div style={styles.singleCol}>
                    <CarportWelcome />
                </div>
            </div>
        </div>
    ) : isSmall ? (
        <div style={styles.flexColumn}>
            <div style={styles.singleCol}>
                <Welcome />
            </div>
            <div style={styles.singleCol}>
                <TerraceWelcome />
            </div>
            <div style={styles.singleCol}>
                <CarportWelcome />
            </div>
        </div>
    ) : (
      <div>
        <div style={styles.flexColumn}>
            <div style={styles.singleCol}>
                <Welcome />
            </div>
        </div>
        <div style={styles.flex}>
            <div style={styles.leftCol}>
                <TerraceWelcome />
            </div>
            <div style={styles.rightCol}>
                <CarportWelcome />
            </div>
        </div>
        </div>
    );
};

export default Dashboard;
